import { inject, Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class OverTheAirUpdateApiService {
    private api: ApiService = inject(ApiService);

    public getSmartDeviceFirmwares = this.api.getFetcher().path('/smart-devices-firmware').method('get').create();
    public checkForSmartDeviceUpdates = this.api
        .getFetcher()
        .path('/smart-devices-firmware/{smartDeviceId}/check-update')
        .method('put')
        .create();
    public updateSmartDeviceFirmware = this.api
        .getFetcher()
        .path('/smart-devices-firmware/{smartDeviceId}/deployment/create')
        .method('post')
        .create();
    public confirmSmartDeviceFirmwareUpdate = this.api
        .getFetcher()
        .path('/smart-devices-firmware/{smartDeviceId}/deployment/confirm')
        .method('put')
        .create();
    public repairSmartDeviceFirmware = this.api
        .getFetcher()
        .path('/smart-devices-firmware/{smartDeviceId}/repair')
        .method('post')
        .create();
    public rollbackSmartDeviceFirmware = this.api
        .getFetcher()
        .path('/smart-devices-firmware/{smartDeviceId}/rollback')
        .method('post')
        .create();
    public overrideSmartDeviceFirmware = this.api
        .getFetcher()
        .path('/smart-devices-firmware/{smartDeviceId}/deployment/override')
        .method('post')
        .create();
    public getSmartDeviceFirmwareStatus = this.api
        .getFetcher()
        .path('/smart-devices-firmware/{smartDeviceId}/deployment/{deploymentId}/status')
        .method('get')
        .create();
}
